import { FormInstance } from 'ssc-ui-react/typings/components/form/types';

import { createSelectors } from '@/store/constructor/createSelectors';
import { createStore } from '@/store/constructor/createStore';

import { GetGroupLastTenHoursParams, getGroupLastTenHoursThroughput } from '../api';
import { LastTenHoursThroughputItem } from '../defined';

type State = {
  loading: boolean;
  throughputForm?: FormInstance;
  throughputList: LastTenHoursThroughputItem[];
};
type Action = {
  getThroughputForm: () => FormInstance | undefined;
  setThroughputForm: (form?: FormInstance) => void;
  getGroupLastTenHoursThroughputAsync: (params?: GetGroupLastTenHoursParams) => Promise<void>;
  getThroughputList: () => LastTenHoursThroughputItem[];
  setThroughputList: (list: LastTenHoursThroughputItem[]) => void;
};

export const useLastTenHoursGroupThroughputStore = createSelectors(
  createStore<State & Action>((set, get) => {
    return {
      throughputForm: undefined,
      loading: false,
      throughputList: [],
      groupDropdownList: [],
      groupIdMap: {},
      groupDropdownListLoading: false,
      getThroughputForm: () => get().throughputForm,
      setThroughputForm: (form) => set({ throughputForm: form }),
      getGroupLastTenHoursThroughputAsync: async (params) => {
        try {
          if (!params || !params.workstation_group_id_list?.length) return;
          set({ loading: true });
          const defaultParams = get().throughputForm?.getFieldsValue();
          const res = await getGroupLastTenHoursThroughput(params);
          set({ throughputList: res.data?.list || [] });
        } catch (error) {
          console.error(error);
        } finally {
          set({ loading: false });
        }
      },
      getThroughputList: () => get().throughputList,
      setThroughputList: (throughputList) => set({ throughputList }),
    };
  }),
);
